import { create } from 'zustand';

/** Largeur max Tailwind des panneaux formateur : `max-w-md` (28rem) ou `max-w-xl` (36rem). */
export type SupportChatFabPanelMaxRem = 28 | 36;

interface SupportChatFabLayoutState {
  /** Pile : un push par panneau monté (en-tête commun), pop au démontage. */
  stack: SupportChatFabPanelMaxRem[];
  pushPanel: (maxWidthRem: SupportChatFabPanelMaxRem) => void;
  popPanel: () => void;
  /**
   * Designer EduFlow : largeur réelle du panneau de droite (px), pour aligner la bulle support
   * sur la même logique que `TrainerRightPanelHeader` (à gauche du bord du panneau).
   */
  designerRightPanelWidthPx: number | null;
  setDesignerRightPanelWidthPx: (widthPx: number | null) => void;
}

export const useSupportChatFabLayout = create<SupportChatFabLayoutState>((set) => ({
  stack: [],
  designerRightPanelWidthPx: null,
  pushPanel: (maxWidthRem) =>
    set((s) => ({
      stack: [...s.stack, maxWidthRem],
    })),
  popPanel: () =>
    set((s) => ({
      stack: s.stack.length ? s.stack.slice(0, -1) : [],
    })),
  setDesignerRightPanelWidthPx: (widthPx) => set({ designerRightPanelWidthPx: widthPx }),
}));

export function getSupportChatFabEffectiveMaxRem(stack: SupportChatFabPanelMaxRem[]): SupportChatFabPanelMaxRem | null {
  if (!stack.length) return null;
  return Math.max(...stack) as SupportChatFabPanelMaxRem;
}
